<style lang="scss" scoped>
	@import "./domainname.css";
</style>
<style>
	.grayc {
		color: #cfcfcf !important;
	}

	.greenc {
		/* color: #0c8b97 !important; */
		color: #808080 !important;
	}
	#domainname .warp_listmin{
		display: inline-block;
		height: 1px;
		width: 3.3%;
	}
</style>
<style lang='scss'>
	#domainname {
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
</style>
<template>
	<div id="domainname">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<a-row type='flex' justify='space-between'>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="信息查詢" class="formItem">
									<a-input v-model="params.domainname_address" placeholder="請輸入合約內容 / 公司名稱" :allowClear="true" @change="handleClear(1)"/>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="域名狀態" class="formItem">
									<a-select v-model="params.status" placeholder="請選擇" @change="searchEvent">
										<a-select-option v-for="(item) in admintypeArr" :key="item.key"
											:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="域名IP" class="formItem">
									<a-input v-model="params.ip" placeholder="請輸入域名IP" :allowClear="true" @change="handleClear(2)"/>
								</a-form-model-item>
							</a-col>
							</a-row><br>
							<a-row type='flex' justify='space-between'>
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="開始日期" class="formItem">
									<a-range-picker :placeholder="['開始日期','完結日期']" format="YYYY/MM/DD"
										v-model="params.timeDate1" @change='fanhand1'>
									</a-range-picker>
								</a-form-model-item>
							</a-col>
							
							<a-col :xl="{ span: 6 }">
								<a-form-model-item label="完結日期" class="formItem">
									<a-range-picker :placeholder="['開始日期','完結日期']" format="YYYY/MM/DD"
										v-model="params.timeDate" @change='fanhand' :disabled-date='disabledStartDate'>
									</a-range-picker>
								</a-form-model-item>
							</a-col>
							
							<a-col :xl="{ span: 6 }" style="display:flex;align-items: center;">
								<div class="btn_cla" style="background-color:#3bc7a1;margin-right:1rem;" @click="searchEvent">
									<img src="../../image/icon_sousuo.png" class="btnIcon" />
									<span>搜索</span>
								</div >
								<div class="btn_cla" style="background-color:#ffa647;"
									@click="clearEvent">
									<img src="../../image/icon_chongzhi.png" class="btnIcon" />
									<span>重置</span>
								</div >
							</a-col>
				</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<div  @click='visible_bold = 1' v-if='domaininsertadmin' class='btn_list'>
					<img src="../../image/emp1.png" class="btnIcon" />
					<span style="color: #ffa647;">添加</span>
				</div>
				<a-upload name="file" :data='{token:$store.state.token}' :headers='{token:$store.state.token}'  v-if='domaininsertadmin'
					class="avatar-uploader" :show-upload-list="false" :action="$api.importDomainNameContractExcel"
					:before-upload="beforeUpload" @change="handleChange">
					<div class='btn_list'>
						<img src="../../image/endexs.png" class="btnIcon" />
						<span style="color:rgb(93, 176, 234);">導入</span>
					</div>
				</a-upload>
				<div  @click="upClick()" class='btn_list'>
					<a-icon type="file-pdf" style='width: .9rem;color: #3bc7a1;marginRight:.3rem;fontSize:.8rem'/>
					<span style="color:#3bc7a1;">導出</span>
				</div>
				<task :params='params' @child='fandfn' v-if='domaineditadmin'></task>
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index' :customRow='rowstely'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<div slot='status' slot-scope="record" style="white-space: nowrap;">
					<div v-if='record.status == "已過期"'>{{record.status}}</div>
					<div v-else-if='record.status == "正常"' >{{record.status}}</div>
					<!-- style='color: #3bc7a1;' -->
					<div v-else>{{record.status}}</div>
					<!--  style='color: #ee5253;' -->
				</div>
				<span slot='regdate' @click='uploadfn("up",1)' style="cursor: pointer;">
					開始日期
					<div style="display: inline-block;position: relative;top: -1rem;">
						<a-icon type="caret-up" :class='params.register_date_sort!=="up"?"grayc":"greenc"'
							style='position: absolute;top: 0;' />
						<a-icon type="caret-down" :class='params.register_date_sort!=="down"?"grayc":"greenc"'
							style='position: absolute;top: .6rem;' />
					</div>
				</span>
				<span slot='expire_date1' @click='uploadfn("up")' style="cursor: pointer;">
					完結日期
					<div style="display: inline-block;position: relative;top: -1rem;">
						<a-icon type="caret-up" :class='params.expire_date_sort!=="up"?"grayc":"greenc"'
							style='position: absolute;top: 0;' />
						<a-icon type="caret-down" :class='params.expire_date_sort!=="down"?"grayc":"greenc"'
							style='position: absolute;top: .6rem;' />
					</div>
				</span>
				<span slot='domainnames'>
					域名類型
					<a-popover placement="top" :destroyTooltipOnHide="true" trigger="hover"
						:overlayStyle="{width:'calc(12rem)'}"
						:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
						<template slot="content">
							<div style="font-size: .75rem;">
								ccTLD：國家和地區頂級域名
								<br>
								<br>
								New gTLD：新通用頂級域名
								<br>
								<br>
								gTLD：通用頂級域名
							</div>
						</template>
						<a-icon type="question-circle" />
					</a-popover>
				</span>
				
				<div slot='supplier' slot-scope='record'>
					<div style="margin-left: 1rem;text-align: left;">{{record.supplier}}</div>
				</div>
				<div slot='domainname_address' slot-scope='record'>
					<div style="margin-left: 1rem;text-align: left;">{{record.domainname_address}}</div>
				</div>
				<div slot='ip' slot-scope='record'>
					<div v-if='record.ip'>{{record.ip}}</div>
					<div v-else style="color: red;">
						<!-- 未綁定 -->
						<img :src="require('../../image/icondom.png')" alt="">
						</div>
				</div>
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div @mouseenter="record.visible_bold = 1" @mouseleave="record.visible_bold = ''">
							<img :src="record.visible_bold !== 1?require('../../image/lea/bianji1.png'):require('../../image/lea/bianji3.png')" 
							class="imageb" @click='handediot(record,1)' v-if='domaineditadmin' 
							:style="{opacity:record.status == '已過期'?'.5':'1'}">
						</div>
						<div class="popoverView" v-if='domaininsertadmin||domaineditadmin'>
							<img :src="record.visible_bold1 !== 2?require('../../image/lea/chakan1.png'):require('../../image/lea/chakan.png')" 
							class="imageb" @click='handediot(record,2)' :style="{opacity:record.status == '已過期'?'.5':'1'}">
							<!-- <ediotitem :record='record' :missionflag='params.missionflag' @child='handclose'></ediotitem> -->
						</div>
						<div class="popoverView" v-if='domaineditadmin'>
							<!-- <img :src="require('../../image/delete.png')" class="imageC" style="width: 1.1rem;" @click='deletefn(record)'> -->
							<!-- <img :src="require('../../image/startend.png')" class="imageC" style="width: 1.1rem;" @click='deletefn(record)'> -->
							<!-- <img :src="require('../../image/startk.png')" class="imageC" style="width: 1.1rem;" @click='deletefn(record)'> -->
						</div>
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()">
			<div class="pdfviewIn">
				<div class="pdfTitle">
					<img @click.stop="printEvent()" src="../../image/icon_dayin.png">
					<!-- <img @click.stop="downLoad()" src="../../image/icon_xiazai1.png"> -->
				</div>
				<iframe id="iframePdf1" :src="allurl" style="width: 100%; height: 100%" frameborder="0"></iframe>
				<iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
			</div>
		</div>
		<exportData  v-if="upFlag" @child="upclose" ></exportData>
		<handItem v-if='visible_bold==1' @child='handclose' :items='isdate'></handItem>
		<handItems v-if='visible_bold==2' @child='handclose' :items='isdate'></handItems>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
	</div>
</template>
<script>
	import exportData from "./components/exportData";
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';
	import icon_pdf from '@/image/icon_xiangqing.png';
	import icon_pdf1 from '@/image/icon_xiangqing_1.png';
	import ediotitem from './components/ediotitem.vue'
	import handItem from './components/handItem'
	import handItems from './components/handItems'
	import {
		saveFileToLink
	} from 'web-downloadfile';
	import task from './components/task.vue'

	export default {
		components: {
			handItem,
			task,
			ediotitem,
			exportData,
			handItems
		},
		data() {
			return {
				upFlag:false,
				ishandout: false,
				allurl: '',
				pdfShow: false,
				pdfBolUrl: '',
				isdate: '',
				visible_bold: '',
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限    
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				icon_pdf,
				icon_pdf1,
				//域名新增權限 domaininsertadmin
				//域名編輯權限 domaineditadmin
				domaininsertadmin: this.$store.state.rolesdata.indexOf('domaininsertadmin') >= 0,
				domaineditadmin: this.$store.state.rolesdata.indexOf('domaineditadmin') >= 0,
				admintypeArr: [{
						text: '全部',
						value: ''
					},{
						text: '正常',
						value: '1'
					},
					{
						text: '已過期',
						value: '2'
					},
					{
						text: '即將到期',
						value: '3'
					},
				],
				tzPageNum: '',
				columns: [
					{
						title: '公司名稱',
						dataIndex: '',
						align: 'center',
						width: '14%',
						scopedSlots: {
							customRender: 'supplier'
						}
					},
					{
						title: '合約內容',
						dataIndex: '',
						align: 'center',
						width: '15%',
						scopedSlots: {
							customRender: 'domainname_address'
						}
					},
					{
						title: '域名IP',
						dataIndex: '',
						align: 'center',
						width: '12%',
						scopedSlots: {
							customRender: 'ip'
						}
					},
					{
						// title: '域名類型',
						dataIndex: 'domainname_type',
						align: 'center',
						width: '12%',
						slots: {
							title: 'domainnames'
						},
					},
					
					{
						// title: '開始日期',
						dataIndex: 'register_date',
						align: 'center',
						width: '13%',
						// sorter: (a, b) => {
						// 	return a.register_date - b.register_date;
						// 	console.log(a,b)
						// },
						slots: {
							title: 'regdate'
						},
					},
					{
						// title: '完結日期',
						dataIndex: 'expire_date',
						align: 'center',
						width: '12%',
						slots: {
							title: 'expire_date1'
						},
					},
					// {
					// 	title: '修改時間',
					// 	dataIndex: 'edittime',
					// 	align: 'center',
					// 	width: '10%',
					// 	slots: {
					// 		title: 'edittime'
					// 	},
					// },
					{
						title: '域名狀態',
						dataIndex: '',
						align: 'center',
						width: '12%',
						scopedSlots: {
							customRender: 'status'
						}
					},

					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					searchstr: '',
					perPage: 10, //每頁條目數
					ip:'',
					"flag": "domainname",
					"register_date_begin": "",
					"register_date_end": "",
					"expire_date_begin": "",
					"expire_date_end": "",
					"domainname_address": "",
					missionflag: 0, //任務中  1
					status: '',
					register_date_sort: '',
					expire_date_sort: '',
					timeDate: [],
					timeDate1: []
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},

		},
		mounted() {
			this.messLoad();
		},
		methods: {
			upclose(val){
				this.upFlag = false;
				if (val.xzgs == 'PDF') {
					this.pdfEvent(val.pxfs)
				}
				if (val.xzgs == 'Excel') {
					this.queryData(val.pxfs)
				}
			},
			// 表格导出下载
			queryData(pxfs){
				let brr  = []
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['domainnameid']){
						brr.push(this.columnsData[ev]['domainnameid'])
					}
				})
				let sort =  pxfs == undefined ? '' : pxfs
				let url = this.$api.domainNameContract
				url += '?token=' + this.$store.state.token 
					+ '&m=' + Date.parse(new Date()) 
					+ '&status=' + this.params.status
					+ '&sort=' + sort
					+ '&domainname_address=' + this.params.domainname_address
					+ '&ip=' + this.params.ip
					+ '&register_date_begin=' + this.params.register_date_begin
					+ '&register_date_end=' + this.params.register_date_end
					+ '&expire_date_begin=' + this.params.expire_date_begin
					+ '&expire_date_end=' + this.params.expire_date_end
					+ '&idList=' + brr.join(',')
				window.location.href = url;
			},
			upClick(){
				this.upFlag = true
			},
			handleCancel(ev){
                this.ishandout = false
			},
			handleClear(val){
				if(val == 1){
					if (!this.params.domainname_address) {
						this.messLoad()
					}
				}
				if(val == 2){
					if (!this.params.ip) {
						this.messLoad()
					}
				}
            },
			downLoad(){
			    let _this = this;
			    saveFileToLink(_this.pdfUrl,'帳戶申請書','pdf');
			},
			printEvent() {
				let _this = this; //toPrintIframe
				const printIframe = document.getElementById("toPrintIframe");
				let frameWindow = printIframe.contentWindow;
				console.log(frameWindow)
				frameWindow.print();
				setTimeout(() => {
					window.URL.revokeObjectURL(_this.blob);
				}, 500)
			},
			pdfShowUNEvent() {
				this.pdfShow = false;
				// this.messLoad();
			},
			pdfEvent(pxfs){
				let brr  = []
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['domainnameid']){
						brr.push(this.columnsData[ev]['domainnameid'])
					}
				})
				console.log(this.$api.pdfs)
				let sort =  pxfs == undefined ? '' : pxfs
				let str = this.$api.pdfs; //getUnsk
				let url = this.$api.getDoMainnameListPdf//getQmisBankInfoPdf;//getDoMainnameListPdf
				// url += '?m=' + Date.parse(new Date())
				url += '?token=' + this.$store.state.token + '&m=' + Date.parse(new Date()) 
				+'&status=' + this.params.status
				+'&sort=' + sort
				+'&domainname_address=' + this.params.domainname_address
				+'&ip=' + this.params.ip
				+'&register_date_begin=' + this.params.register_date_begin
				+'&register_date_end=' + this.params.register_date_end
				+'&expire_date_begin=' + this.params.expire_date_begin
				+'&expire_date_end=' + this.params.expire_date_end
				+ '&idList=' + brr.join(',')
				// + '&bankidList=' + brr.join(',')
				this.allurl = str + url
				console.log(url)
				let _this = this;
				_this.pdfUrl = url
				https.fetchGetPdf(_this.pdfUrl).then((data) => {
					let blob = new Blob([data], {
						type: 'application/pdf'
					});
					_this.blob = blob;
					let b = window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err => {
					console.log(err);
				});
							
				setTimeout(() => {
					this.pdfShow = true;
				}, 500);
			},
			disabledStartDate(startValue) {
				if(this.params.timeDate1[1]){
					const endValue = this.params.timeDate1[1];
					console.log(this.params.timeDate1[1])
					if (!startValue || !endValue) {
					  return false;
					}
					return startValue.valueOf() < endValue.valueOf();
				}
			  },
			rowstely(record, index) {
				if (record.status == "已過期") {
					return {
						style: {
							'color': '#999',
							opcity:'.5'
						},
					}
				}
			},
			uploadfn(val, a) {
				if (a) {
					if (this.params.register_date_sort == 'up') {
						this.params.register_date_sort = 'down'
					} else if (this.params.register_date_sort == 'down') {
						this.params.register_date_sort = ''
					} else if (this.params.register_date_sort == '') {
						this.params.register_date_sort = 'up'
					}
				} else {
					if (this.params.expire_date_sort == 'up') {
						this.params.expire_date_sort = 'down'
					} else if (this.params.expire_date_sort == 'down') {
						this.params.expire_date_sort = ''
					} else if (this.params.expire_date_sort == '') {
						this.params.expire_date_sort = 'up'
					}
				}
				this.messLoad();
			},
			deletefn(ev) {
				this.$ajax({
					method: 'post',
					url: this.$api.deletOther,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"token": this.$store.state.token,
						"domainnameid": ev.domainnameid,
						"flag": "domainname"
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.$message.success('操作成功')
						this.messLoad();
					} else {
						this.$message.warning(res.data.qmismsg)
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handediot(val, a) {
				this.isdate = val.domainnameid;
				// console.log(val)
				this.visible_bold = a;
				if(a==1){
					val.visible_bold = a
				}else{
					val.visible_bold1 = a
				}
			},
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			fandfn(val) {
				if (val == 'back') {
					this.params.missionflag = 0
					this.params.status = ''
				} else {
					this.params.missionflag = 1
					this.params.status = val == '即將到期' ? '3' : ''
				}
				this.messLoad()
			},
			handopen() {
				window.location.href = this.$api.getExcel + '?token=' + this.$store.state.token
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},

			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.expire_date_begin = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]
						._d) : '',
					//認購截止日期
					this.params.expire_date_end = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]
						._d) : ''
			},
			fanhand1(val) {
				this.params.register_date_begin = this.params.timeDate1[0] ? App.oDate.secsTime3(this.params.timeDate1[0]
						._d) : '',
					//認購截止日期
					this.params.register_date_end = this.params.timeDate1[1] ? App.oDate.secsTime3(this.params.timeDate1[1]
						._d) : ''
			},
			handland(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"type": val
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {

					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handclose(val) {
				this.columnsData.map(ev => {
					for (let key in ev) {
						ev['visible_bold'] = ''
						ev['visible_bold1'] = ''
					}
				})
				this.isdate = ''
				this.visible_bold = '';
				if (val) {
					this.messLoad();
				}
			},
			messLoad() {
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.getlsi,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.resultlist
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['visible_bold'] = ''
								ev['visible_bold1'] = ''
							}
						})
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
						if (this.params.domainname_address || this.params.status || this.params.ip || this.this.params.register_date_begin ||this.this.params.expire_date_begin ) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
						console.log(this.params)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},

			clearEvent() {
				this.params = {}
				this.params = {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					searchstr: '',
					perPage: 10, //每頁條目數
					ip:'',
					"flag": "domainname",
					"register_date_begin": "",
					"register_date_end": "",
					"expire_date_begin": "",
					"expire_date_end": "",
					"domainname_address": "",
					missionflag: 0, //任務中  1
					status: '',
					timeDate: [],
					register_date_sort: '',
					expire_date_sort: '',
					timeDate1: []
				}
				this.messLoad();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
	};
</script>
